import { useTranslation } from 'react-i18next';
import Icon from '../../ui/Icon/Icon';
import styles from './BrowserFrame.module.css';

interface BrowserFrameProps {
    src: string;
    url: string;
    href: string;
    alt: string;
}

const WINDOW_DOTS = 3;

export default function BrowserFrame({ src, url, href, alt }: BrowserFrameProps) {
    const { t } = useTranslation();

    return (
        <a className={styles.frame} href={href} target="_blank" rel="noopener noreferrer">
            <span className={styles.bar}>
                <span className={styles.dots} aria-hidden="true">
                    {Array.from({ length: WINDOW_DOTS }, (_, index) => <span key={index} />)}
                </span>
                <span className={styles.url}>{url}</span>
                <Icon name="arrowUpRight" className={styles.icon} />
                <span className="visually-hidden">{t('a11y.opensInNewTab')}</span>
            </span>
            <img className={styles.screenshot} src={src} alt={alt} width={1200} height={750} loading="lazy" decoding="async" />
        </a>
    );
}
